<script>
export default {
  data() {
    return {
      isSm: false,
      isMd: false,
      isLg: false,
      owlSm: null,
      owlMd: null,
      owlLg: null,
    };
  },

  methods: {
    setWidth() {
      this.isSm = window.matchMedia("(max-width: 750px)").matches;
      this.isMd =
        window.matchMedia("(min-width: 751px)").matches &&
        window.matchMedia("(max-width: 990px)").matches;
      this.isLg = window.matchMedia("(min-width: 991px)").matches;
    },

    owl(element) {
      return element.owlCarousel({
        items: 1,
        autoplay: false,
        dots: false,
        nav: true,
        navText: [],
      });
    },

    loadOwl() {
      this.$nextTick(function () {
        if (this.isSm && !this.owlSm) {
          this.owlSm = this.owl($(".owl-sm .owl-carousel"));
        }

        if (this.isMd && !this.owlMd) {
          this.owlMd = this.owl($(".owl-md .owl-carousel"));
        }

        if (this.isLg && !this.owlLg) {
          this.owlLg = this.owl($(".owl-lg .owl-carousel"));
        }
      });
    },
  },

  mounted() {
    this.setWidth();
    this.loadOwl();

    //

    window.addEventListener("resize", () => {
      this.setWidth();
      this.loadOwl();
    });
  },

  render() {
    return this.$scopedSlots.default({
      isSm: this.isSm,
      isMd: this.isMd,
      isLg: this.isLg,
    });
  },
};
</script>